import {
  GetInitialVisitAccessoryListQueryParamsType,
  GetInitialVisitAccessoryListQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitAccessoryList/getInitialVisitAccessoryListQuery.type';
import { getInitialVisitAccessoryListFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitAccessoryList/getInitialVisitAccessoryListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInitialVisitAccessoryListQueryOptions = (
  params: GetInitialVisitAccessoryListQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getInitialVisitAccessoryListQueryOptions', params],
    queryFn: () => getInitialVisitAccessoryListFunction(params),
    select: (data: GetInitialVisitAccessoryListQueryResponseType) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        id: data?.parts?.map((item) => ({ id: item?.id })),
        substitution: { ...data },
        cartData: data?.parts?.map((item) => [
          {
            name: 'نام قطعه',
            value: item?.name,
          },
          {
            name: 'نوع و مدل :',
            value: item?.model,
          },
          {
            name: 'تعداد :',
            value: item?.number,
          },
          {
            name: 'قیمت :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.price)} ریال`,
          },
        ]),
      };
    },
  });
};
